// components/MultiStepForm/FormActions.tsx
import buttonStyles from '@/styles/buttons.module.css'
import styles from './FormActions.module.css'

interface FormActionsProps {
  currentStep: number
  totalSteps: number
  onBack?: () => void
  onNext?: () => void
  onCancel?: () => void
  onSubmit?: () => void
  isSubmitting?: boolean
}

export const FormActions = ({ currentStep, totalSteps, onBack, onNext, onCancel, onSubmit, isSubmitting = false }: FormActionsProps) => {
  const isFirstStep = currentStep === 1
  const isLastStep = currentStep === totalSteps

  return (
    <div className={styles.Container}>
      <div className={styles.LeftActions}>
        {!isFirstStep && (
          <button type="button" onClick={onBack} className={buttonStyles['button-outline']}>
            Back
          </button>
        )}
      </div>
      <div className={styles.RightActions}>
        {isFirstStep && (
          <button type="button" onClick={onCancel} className={buttonStyles['button-outline']} disabled={isSubmitting}>
            Cancel
          </button>
        )}
        {isLastStep ? (
          <button type="button" onClick={onSubmit} className={buttonStyles['button-primary']} disabled={isSubmitting}>
            {isSubmitting ? 'Submitting...' : 'Submit'}
          </button>
        ) : (
          <button type="button" onClick={onNext} className={buttonStyles['button-primary']} disabled={isSubmitting}>
            Next
          </button>
        )}
      </div>
    </div>
  )
}
